module.exports = __webpack_public_path__ + "img/pics_active-local-listing.549e49f9.svg";